import { Injectable } from '@angular/core';
import { filter, switchMap } from 'rxjs/operators';
import { HubService } from '../../core/services/hub.service';
import { SignalRHttpClient } from '../../core/services/signal-r-http-client';
import { ModalService } from '../../core/services/modal.service';
import { TranslateService } from '../../core/translate/translate.service';
import { AuthFacade } from '../../stores/auth/facades/auth.facade';
import { TaskNotification } from '../models';
import { TaskNotificationsHttpService } from './task-notifications-http.service';
import { TaskNotificationsService } from './task-notifications.service';
import { SocketsManagerService } from '../../sockets-manager/services';
import { CoreFacade } from 'src/app/stores/core/facades/core.facade';

@Injectable({
  providedIn: 'root'
})
export class TaskNotificationsHubService extends HubService {

  constructor(
      protected signalRHttpClient: SignalRHttpClient,
      protected modalService: ModalService,
      protected translate: TranslateService,
      protected authFacade: AuthFacade,
      private taskNotificationsHttpService: TaskNotificationsHttpService,
      private taskNotificationsService: TaskNotificationsService,
      protected socketsManagerService: SocketsManagerService,
      protected _coreFacade: CoreFacade
  ) {
    super('hubs/Tasks', modalService, translate, signalRHttpClient, authFacade, socketsManagerService, _coreFacade);
    this.initializeTaskNotifications();
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  
  protected override onInit(): void {
    this.onTaskNotification();
    this.onUpdateTaskNotification();
  }

  protected override onConnection(): void { }
    
  protected override onDisconnect(): void {
    super.onDisconnect();
  }
  
  private onTaskNotification(): void {
    this.hubConnection.on('TaskNotification', (taskNotification: TaskNotification) => {
      this.taskNotificationsService.updateTaskNotification(taskNotification);
    });
  }
  
  private onUpdateTaskNotification(): void {
    this.hubConnection.on('UpdateTaskNotification', (taskNotification: TaskNotification) => {
      this.taskNotificationsService.updateTaskNotification(taskNotification);
    });
  }
  
  private initializeTaskNotifications(): void {
    this.authFacade.getLoggedIn$.pipe(
        filter((isLoggedIn: boolean) => isLoggedIn),
        switchMap(() => this.taskNotificationsHttpService.getTasks())
    ).subscribe((taskNotifications: TaskNotification[]) => {
        this.taskNotificationsService.setTaskNotifications(taskNotifications);
    });
  }
}
